import { OwAppTile } from '../interfaces/domain/ow-app-tile.modal';
import { SearchResultDTO } from '../interfaces/dtos/search-result.dto';
import { ISearchService } from '../interfaces/services/search-service.interface';
import { DataFetchService } from './data-fetch.service';
import { LoggerService } from '@ow/shared/services/logger.service';

const log = LoggerService.getCategory('RemoteSearchService');

// ---------------------------------------------------------------------------
export class RemoteSearchService implements ISearchService {
  private readonly config: any;

  // ---------------------------------------------------------------------------
  constructor(config: any) {
    this.config = config;
  }

  // ---------------------------------------------------------------------------
  public async getSearchItems(name: string): Promise<OwAppTile[]> {
    try {
      if (!name) {
        return [];
      };

      if (name?.length < 3) {
        return [];
      };

      // Relative (same-origin) on purpose: this service only runs in the
      // browser, and next-api/* has no CORS headers. Prefixing the configured
      // baseUrl (www.overwolf.com) made every search from a non-www host —
      // e.g. https://overwolf.com/search?q=x — a blocked cross-origin request.
      const result = await DataFetchService.get<SearchResultDTO>(
        `/next-api/search?q=${encodeURIComponent(name)}`
      );

      if (!result) {
        return [];
      }

      return result.searchResult as OwAppTile[];
    } catch (e) {
      log.error(`Failed to get search for: ${name}. ${e.message}`);
    }

    return [];
  }
}
